import { useEffect, useState } from "react";
import styles from "./entry_rule_override_modal.module.css";
import { Dialog, TextField } from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";

export default function DataEntryOverrideModal(props) {
  const { isOpen, close, onYes } = props;
  const [modalText, setModalText] = useState("");

  return (
    <Dialog open={isOpen} onClose={close}>
      <div className={styles.modal_wrapper}>
        <div className={styles.modal_title}>Override Data Entry Rule</div>
        <div className={styles.modal_body}>
          <div className={styles.are_you_sure}>
            Please provide a reason for overriding the data entry rules for this item.
          </div>
          <div className={styles.text_entry}>
            <TextField
              placeholder=""
              value={modalText}
              onChange={(e) => setModalText(e.target.value)}
              autoComplete="off"
              sx={{
                "& .MuiInputBase-input": {
                  padding: "5px",
                  paddingLeft: "10px",
                  textAlign: "left",
                },
              }}
              fullWidth
              multiline
            />
          </div>
        </div>
        <div className={styles.modal_button_wrapper}>
          <LoadingButton
            disabled={modalText.length < 8}
            variant="contained"
            loading={false}
            onClick={() => onYes(modalText)}
          >
            Continue
          </LoadingButton>
          <LoadingButton disabled={false} variant="outlined" loading={false} onClick={close}>
            Cancel
          </LoadingButton>
        </div>
      </div>
    </Dialog>
  );
}
